<template>
  <div class="main-tab px-5 pt-2">
    <div class="main-tab__form">
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <AutoComplete
              v-model="eximSchemeDropdownValue"
              rules="required"
              :items="eximSchemeCodes"
              item-text="text"
              @change="checkAndEximSchemeRelated"
              :return-object="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="EXIM Scheme"
            />
          </v-col>
          <v-col cols="12" :xs="4" :sm="2" :md="2">
            <v-checkbox v-model="rewardItem" :value="rewardItem" label="Reward Item"></v-checkbox>
          </v-col>
          <v-col cols="12" :xs="4" :sm="2" :md="2">
            <v-checkbox v-model="isThirdParty" :value="isThirdParty" label="Third Party"></v-checkbox>
          </v-col>
          <v-col cols="12" :xs="4" :sm="2" :md="2">
            <v-checkbox v-model="isSWInfoReqd" label="SW Info"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" :xs="6" :sm="4" :md="4">
            <TextField
              v-model="sqcQty"
              type="number"
              showIcons
              required
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="SQC Qty"
            />
          </v-col>
          <v-col cols="6" :xs="6" :sm="2" :md="2">
            <AutoComplete
              v-model="sqcQtyUnit"
              item-text="text"
              item-value="textIdentifier"
              :return-object="true"
              :items="units"
              required
              label="SQC Units"
              :loading="isMainTabFormLoading || savingExportJob"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <AutoComplete
              v-model="originDistrict"
              rules="required"
              item-text="name"
              item-value="code"
              :return-object="true"
              :items="districtCodes"
              :loading="isMainTabFormLoading || savingExportJob"
              label="Origin District"
            />
          </v-col>
          <!-- <v-col cols="6" :xs="6" :sm="4" :md="4">
            <TextField
              v-model="alternateQty"
              type="number"
              showIcons
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="Alternate Qty"
            />
          </v-col>
          <v-col cols="6" :xs="6" :sm="2" :md="2">
            <AutoComplete
              v-model="alternateQtyUnit"
              :return-object="true"
              item-text="text"
              item-value="code"
              :items="units"
              label="Units"
              :loading="isMainTabFormLoading || savingExportJob"
            />
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <AutoComplete
              v-model="ptaFta"
              :return-object="true"
              rules="required"
              :items="ptaFtas"
              item-text="text"
              item-value="textIdentifier"
              :loading="isMainTabFormLoading || savingExportJob"
              label="PTA/FTA"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <AutoComplete
              :return-object="true"
              v-model="endDropdownValue"
              :items="endUses"
              required
              rules="required"
              showIcons
              :showOnlyErrorIcons="true"
              item-text="text"
              :loading="isMainTabFormLoading || savingExportJob"
              label="End"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <AutoComplete
              :return-object="true"
              v-model="igstPaymentStatusDropdownValue"
              rules="required"
              :items="igstPaymentStatus"
              item-text="text"
              showIcons
              required
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="IGST Payment Status"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <TextField
              v-model="igstTaxableValue"
              type="number"
              showIcons
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="Taxable Value (INR)"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <TextField
              v-model="igstPercent"
              type="number"
              showIcons
              :disabled="isPaid"
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="IGST Rate"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <TextField
              v-model="igstAmount"
              type="number"
              showIcons
              :disabled="isLut || isPaid"
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="IGST Amount (INR)"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6">
            <TextField
              v-model="cessPercent"
              type="number"
              showIcons
              :disabled="isLut || isPaid"
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="Comp CESS %"
            />
          </v-col>
          <v-col cols="6" :xs="12" :sm="6" :md="3">
            <TextField
              v-model="cessAmount"
              type="number"
              showIcons
              :disabled="isLut || isPaid"
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="CESS Amount (INR)"
            />
          </v-col>
          <v-col cols="6" :xs="12" :sm="6" :md="3">
            <AutoComplete
              v-model="rodtepClaimed"
              showIcons
              :showOnlyErrorIcons="true"
              :loading="isMainTabFormLoading || savingExportJob"
              label="RoDTEP Claimed"
              :return-object="true"
              :items="rodteps"
              required
              rules="required"
              item-text="text"
              item-value="textIdentifier"
            />
          </v-col>
        </v-row>

        <div class="main-tab__form__pmv pa-4 px-6 mt-4 mb-4">
          <span class="font-weight-medium" :class="{ 'fs-20': !breakpointXs, 'fs-15': breakpointXs }">
            Present Market Value (PMV)
          </span>
          <v-row>
            <v-col cols="6" :xs="6" :sm="3" :md="2" class="d-flex align-center justify-center">
              <span class="fs-17 font-weight-medium">Calc. Meth.</span>
            </v-col>
            <v-col cols="6" :xs="6" :sm="4" :md="4">
              <TextField
                v-model="pmvCalculationPercentage"
                rules="required"
                :loading="isMainTabFormLoading || savingExportJob"
                label="%age"
              />
            </v-col>
            <v-col cols="6" :xs="12" :sm="3" :md="2" class="d-flex align-center justify-center">
              <span class="fs-17 font-weight-medium">Total PMV (INR)</span>
            </v-col>
            <v-col cols="6" :xs="6" :sm="4" :md="4">
              <TextField v-model="pmv" rules="required" :loading="isMainTabFormLoading || savingExportJob" />
            </v-col>
          </v-row>
        </div>

        <!-- <div class="main-tab__table py-8">
          <div
            class="main-tab__table__header d-sm-flex justify-space-between align-center"
            :class="{ 'text-center': breakpointXs }"
          >
            <v-text-field v-model="search" label="Search" single-line hide-details class="mw-25"></v-text-field>
            <v-btn color="button-primary" class="white--text" :class="{ 'mt-4': breakpointXs }" @click="dialog = true">
              <span class="font-weight-bold">Add</span>
            </v-btn>
          </div>
          <div class="main-tab__table__body mt-5">
            <v-data-table items-per-page="5" items-per-page="5"  :headers="tableHeaders" :items="[]" :search="search">
              <template v-slot:item.action="{ item }">
                <v-btn color="lightPrimary" class="info font-weight-bold mx-2" dense @click="updateActionHandler(item)"
                  >Edit</v-btn
                >
                <v-btn color="lightPrimary" class=" error font-weight-bold" dense @click="deleteActionHandler(item)"
                  >Delete</v-btn
                >
              </template>
            </v-data-table items-per-page="5" >
          </div>
        </div> -->
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
              <v-btn
                width="140"
                color="info"
                large
                class="white--text"
                :loading="isMainTabFormLoading || savingExportJob"
                @click="$emit('change-tab', 0)"
              >
                <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                <span class="font-weight-bold fs-15">Previous</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
              <v-btn
                width="140"
                color="button-primary"
                large
                class="white--text"
                :loading="isMainTabFormLoading || savingExportJob"
                @click="passes(saveMainTab)"
              >
                <span class="font-weight-bold fs-15">Save</span>
              </v-btn>
              <div class="ml-2 mr-2 my-1"></div>
              <v-btn
                width="140"
                color="info"
                large
                class="white--text"
                :loading="isMainTabFormLoading || savingExportJob"
                @click="tabChangeHandler"
              >
                <span class="font-weight-bold fs-15">Next</span>
                <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>
    <ConfirmDeleteDialog
      @clicked-yes="deleteEximSchemeRelated"
      :name="deleteDialogMessage"
      @clicked-no="setDefaultEximScheme"
      v-if="showDeleteConfirmationDialog"
    />
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "MainTab",
  components: {
    ValidationObserver,
    TextField,
    ConfirmDeleteDialog,
    AutoComplete
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    },
    isNewItem: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      igstRate: null,
      igstTaxableValueDisplay: null,
      cessPercent: null,
      alternateQty: "",
      alternateQtyUnit: "",
      category: "",
      isLut: false,
      isPaid: false,
      isSWInfoReqd: false,
      showBifurcation: false,
      isMainTabFormLoading: false,
      search: "",
      dialog: false,
      description: "",
      agencyCode: "",
      agencyName: "",
      documentName: "",
      isAddMainTabDialogFormLoading: false,
      sqcQtyDuplicate: null,
      sqcQtyUnitDuplicate: null,
      cessAmountDuplicate: null,
      ptaFtaDuplicate: null,
      originDistrictDuplicate: null,
      originStateDuplicate: null,
      previousEximSchemeCode: {
        code: null,
        text: null
      },
      showDeleteConfirmationDialog: false,
      deleteDialogMessage: "Previous Schemes Will be Deleted"
    };
  },
  beforeDestroy() {
    // this.makeFieldsNull();
  },
  mounted() {
    this.getInitialSWValues();
    this.checkRewardItem();
    this.checkThirdParty();
    this.checkRodtep();
    this.checkIgstPaymentStatus();
    this.storePreviousEximSchemeCode();

    // this.checkSqcQty();
  },

  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    saveMainTab() {
      const item = { ...this.$store.getters.item };
      const schemeAbbreviations = this.$store.getters.schemeAbbreviations;
      item.invoiceSrNo = this.invoiceSrNo;
      item.itemSrNo = this.itemSrNo;
      this.$store.commit(MT.SET_ITEMS_IN_EXPORT_JOB, item);
      this.$store.commit(MT.SET_SCHEME_ABBREVIATION_IN_EXPORT_JOB, {
        invoiceSrNo: this.invoiceSrNo,
        itemSrNo: this.itemSrNo,
        schemeAbbreviation: schemeAbbreviations
      });
      this.saveSwDetails();
      this.saveExportJob();
      return;
    },
    checkIgstPaymentStatus() {
      const igstPaymentStatus = this.$store.state.ExportModuleStore.item.igstPaymentStatus;
      if (igstPaymentStatus === "LUT") {
        this.isLut = true;
        this.isPaid = true;
        return;
      } else if (igstPaymentStatus === "P") {
        this.isPaid = false;
        this.isLut = true;
        return;
      }
    },
    rodtepDeclarationObject(selection) {
      const rodtepDeclaration = { ...this.$store.getters.statement };
      rodtepDeclaration.invoiceSrNo = this.invoiceSrNo;
      rodtepDeclaration.itemSrNo = this.itemSrNo;
      rodtepDeclaration.srNo = 3;
      rodtepDeclaration.statementType = "DEC";
      rodtepDeclaration.statementCode = selection.statementCode;
      rodtepDeclaration.statementText = selection.statementText;
      return rodtepDeclaration;
    },
    // splitSchemes(selectedSchemeCodeObject){
    //     // var schemes = [];
    // const schemes = selectedSchemeCodeObject.applicableExpSchemes.split(",");
    //   schemes.forEach(scheme => {

    //     });
    //     console.log(schemes,"schemes");
    // },
    setInvoiceAndItemSrNo(swInfoType) {
      swInfoType.invoiceSrNo = this.invoiceSrNo;
      swInfoType.itemSrNo = this.itemSrNo;
      return swInfoType;
    },
    checkRewardItem() {
      const rewardItem = this.$store.state.ExportModuleStore.item.rewardItem;
      if (rewardItem === null || rewardItem === "Y") {
        this.rewardItem = true;
      } else {
        this.rewardItem = false;
      }
      return;
    },
    storePreviousEximSchemeCode() {
      const itemSchemeCode = this.$store.state.ExportModuleStore.item.schemeCode;
      if (itemSchemeCode === null) {
        this.previousEximSchemeCode.code = null;
        this.previousEximSchemeCode.text = null;
        return;
      }
      const CurrentEximScheme = this.eximSchemeCodes.find(eximScheme => {
        return eximScheme.code === itemSchemeCode;
      });
      Object.assign(this.previousEximSchemeCode, CurrentEximScheme);
      return;
    },
    tabChangeHandler() {
      // const schemeCode = this.$store.state.ExportModuleStore.item.schemeCode;
      const eximSchemeCode = this.eximSchemeCodes.find(eximScheme => {
        return eximScheme.code === this.previousEximSchemeCode.code;
      });
      if (
        eximSchemeCode.applicableExpSchemes.includes("DBK") ||
        eximSchemeCode.applicableExpSchemes.includes("DEEC") ||
        eximSchemeCode.applicableExpSchemes.includes("EPCG")
      ) {
        this.$emit("change-tab", 4);
        return;
      }
    },
    checkThirdParty() {
      const isThirdParty = this.$store.state.ExportModuleStore.item.isThirdParty;

      if (isThirdParty === null || isThirdParty === "N") {
        this.isThirdParty = false;
      } else {
        this.isThirdParty = true;
      }
      return;
    },
    checkRodtep() {
      const rodtepClaimed = this.$store.state.ExportModuleStore.item.rodtepClaimed;

      if (rodtepClaimed === null || rodtepClaimed === undefined) {
        this.rodtepClaimed = { textIdentifier: "N" };
      } else {
        this.isThirdParty = { textIdentifier: "Y" };
      }
      return;
    },
    setDefaultEximScheme() {
      if (this.previousEximSchemeCode.code !== null) {
        const eximSchemeCode = this.eximSchemeCodes.find(eximScheme => {
          return eximScheme.code === this.previousEximSchemeCode.code;
        });
        this.eximSchemeDropdownValue = eximSchemeCode;
      } else {
        this.eximSchemeDropdownValue = {
          code: null,
          text: null
        };
      }
      this.showDeleteConfirmationDialog = false;
      return;
    },
    checkAndEximSchemeRelated() {
      const item = { ...this.$store.getters.item };
      item.invoiceSrNo = this.invoiceSrNo;
      item.itemSrNo = this.itemSrNo;
      if (this.previousEximSchemeCode.code !== null) {
        const eximSchemeCode = this.eximSchemeCodes.find(eximScheme => {
          return eximScheme.code === item.schemeCode;
        });
        if (eximSchemeCode !== undefined && eximSchemeCode !== null) {
          if (this.previousEximSchemeCode.code === eximSchemeCode.code) {
            return true;
          } else {
            this.showDeleteConfirmationDialog = true;
            return false;
          }
        }
      } else {
        const eximSchemeCode = this.eximSchemeCodes.find(eximScheme => {
          return eximScheme.code === item.schemeCode;
        });
        Object.assign(this.previousEximSchemeCode, eximSchemeCode);
      }
    },
    deleteEximSchemeRelated() {
      const item = { ...this.$store.getters.item };
      item.invoiceSrNo = this.invoiceSrNo;
      item.itemSrNo = this.itemSrNo;
      const eximSchemeCode = this.eximSchemeCodes.find(eximScheme => {
        return eximScheme.code === this.previousEximSchemeCode.code;
      });
      //   const schemeAbbreviation = { ...this.$store.getters.schemeAbbreviation };
      const schemes = eximSchemeCode.applicableExpSchemes.split(",");
      schemes.forEach(() => {
        this.$store.commit(MT.REMOVE_PREVIOUS_EXIM_SCHEME_RELATED_FROM_EXPORT_JOB, {
          scheme: this.previousEximSchemeCode.applicableExpSchemes,
          invoiceSrNo: this.invoiceSrNo,
          itemSrNo: this.itemSrNo
        });
      });
      this.showDeleteConfirmationDialog = false;
      const CurrentEximScheme = this.eximSchemeCodes.find(eximScheme => {
        return eximScheme.code === item.schemeCode;
      });
      Object.assign(this.previousEximSchemeCode, CurrentEximScheme);
    },
    getInitialSWValues() {
      // sqc value mounted area
      const sqcInfoTypeItem = this.$store.state.ExportModuleStore.exportJob.swInfoTypes.find(
        swInfoType =>
          swInfoType.infoQualifier == "SQC" &&
          swInfoType.itemSrNo === this.itemSrNo &&
          swInfoType.invoiceSrNo === swInfoType.invoiceSrNo
      );

      this.sqcQtyDuplicate = sqcInfoTypeItem !== undefined ? sqcInfoTypeItem.infoMsr : null;
      // item-text="text"
      // item-value="textIdentifier"
      this.sqcQtyUnitDuplicate =
        sqcInfoTypeItem !== undefined
          ? { textIdentifier: sqcInfoTypeItem.infoUqc }
          : { textIdentifier: this.$store.getters.item.unitOfMeasurement };

      // Cess
      const cessInfoTypeItem = this.$store.state.ExportModuleStore.exportJob.swInfoTypes.find(
        swInfoType =>
          swInfoType.infoQualifier == "GCESS" &&
          swInfoType.itemSrNo === this.itemSrNo &&
          swInfoType.invoiceSrNo === swInfoType.invoiceSrNo
      );

      this.cessAmountDuplicate = cessInfoTypeItem !== undefined ? cessInfoTypeItem.infoMsr : null;

      // PTA/FTA
      const ptaFtaInfoTypeItem = this.$store.state.ExportModuleStore.exportJob.swInfoTypes.find(
        swInfoType =>
          swInfoType.infoQualifier == "EPT" &&
          swInfoType.itemSrNo === this.itemSrNo &&
          swInfoType.invoiceSrNo === swInfoType.invoiceSrNo
      );

      this.ptaFtaDuplicate =
        ptaFtaInfoTypeItem !== undefined
          ? { text: ptaFtaInfoTypeItem.infoMsrDropdownValue, textIdentifier: ptaFtaInfoTypeItem.infoCode }
          : null;

      // Origin District
      const originDistrictInfoTypeItem = this.$store.state.ExportModuleStore.exportJob.swInfoTypes.find(
        swInfoType =>
          swInfoType.infoQualifier == "DOO" &&
          swInfoType.itemSrNo === this.itemSrNo &&
          swInfoType.invoiceSrNo === swInfoType.invoiceSrNo
      );

      this.originDistrictDuplicate =
        originDistrictInfoTypeItem !== undefined
          ? {
              name: originDistrictInfoTypeItem.infoMsrDropdownValue,
              code: originDistrictInfoTypeItem.infoCode
            }
          : null;

      // origin state
      const originStateInfoTypeItem = this.$store.state.ExportModuleStore.exportJob.swInfoTypes.find(
        swInfoType =>
          swInfoType.infoQualifier == "STO" &&
          swInfoType.itemSrNo === this.itemSrNo &&
          swInfoType.invoiceSrNo === swInfoType.invoiceSrNo
      );

      this.originStateDuplicate =
        originStateInfoTypeItem !== undefined
          ? { name: originStateInfoTypeItem.infoMsrDropdownValue, stateCode: originStateInfoTypeItem.infoCode }
          : null;

      return;
    },
    saveSwDetails() {
      this.$store.commit(MT.REMOVE_SW_INFO_TYPE_FROM_EXPORT_JOB_FOR_RELATED_ITEMS, {
        invoiceSrNo: this.invoiceSrNo,
        itemSrNo: this.itemSrNo
      });

      // sqc qty sw info type
      var sqcSwInfoType = { ...this.$store.getters.swInfoType };
      sqcSwInfoType = this.setInvoiceAndItemSrNo(sqcSwInfoType);
      sqcSwInfoType.srNo = 1;
      sqcSwInfoType.infoType = "CHR";
      sqcSwInfoType.infoQualifier = "SQC";
      sqcSwInfoType.infoCode = null;
      sqcSwInfoType.infoText = null;
      sqcSwInfoType.infoMsr = parseFloat(this.sqcQty).toFixed(6);
      sqcSwInfoType.infoUqc = this.sqcQtyUnit.textIdentifier;
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, sqcSwInfoType);

      // cess sw info type
      var cessSwInfoType = { ...this.$store.getters.swInfoType };
      cessSwInfoType = this.setInvoiceAndItemSrNo(cessSwInfoType);
      cessSwInfoType.srNo = 2;
      cessSwInfoType.infoType = "DTY";
      cessSwInfoType.infoQualifier = "GCESS";
      cessSwInfoType.infoCode = null;
      cessSwInfoType.infoText = null;
      cessSwInfoType.infoMsr = parseFloat(this.cessAmount).toFixed(6);
      cessSwInfoType.infoUqc = "INR";
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, cessSwInfoType);

      // origin state sw info type
      // originState has stateCode
      var originStateSwInfoType = { ...this.$store.getters.swInfoType };
      originStateSwInfoType = this.setInvoiceAndItemSrNo(originStateSwInfoType);
      const stateCodeObj = this.states.find(state => state.code === this.originState.stateCode);
      originStateSwInfoType.srNo = 3;
      originStateSwInfoType.infoType = "ORC";
      originStateSwInfoType.infoQualifier = "STO";
      originStateSwInfoType.infoCode = this.originState.stateCode;
      originStateSwInfoType.infoText = null;
      originStateSwInfoType.infoMsr = null;
      originStateSwInfoType.infoMsrDropdownValue = stateCodeObj.text;
      originStateSwInfoType.infoUqc = null;
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, originStateSwInfoType);

      // origin state sw info type
      var originDistrictSwInfoType = { ...this.$store.getters.swInfoType };
      originDistrictSwInfoType = this.setInvoiceAndItemSrNo(originDistrictSwInfoType);
      const districtCodeObj = this.districtCodes.find(districtCode => districtCode.code === this.originDistrict.code);
      originDistrictSwInfoType.srNo = 4;
      originDistrictSwInfoType.infoType = "ORC";
      originDistrictSwInfoType.infoQualifier = "DOO";
      originDistrictSwInfoType.infoCode = this.originDistrict.code;
      originDistrictSwInfoType.infoText = null;
      originDistrictSwInfoType.infoMsr = null;
      originDistrictSwInfoType.infoMsrDropdownValue = districtCodeObj.name;
      originDistrictSwInfoType.infoUqc = null;
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, originDistrictSwInfoType);

      // ptaFta sw info type
      var ptaFtaSwInfoType = { ...this.$store.getters.swInfoType };
      ptaFtaSwInfoType = this.setInvoiceAndItemSrNo(ptaFtaSwInfoType);
      ptaFtaSwInfoType.srNo = 5;
      ptaFtaSwInfoType.infoType = "ORC";
      ptaFtaSwInfoType.infoQualifier = "EPT";
      ptaFtaSwInfoType.infoCode = this.ptaFta;
      ptaFtaSwInfoType.infoText = null;
      ptaFtaSwInfoType.infoMsr = null;
      ptaFtaSwInfoType.infoUqc = null;
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, ptaFtaSwInfoType);

      // Rodtep sw info type

      const rodtepClaimed = this.$store.state.ExportModuleStore.item.rodtepClaimed;
      var rodtepSwInfoType = { ...this.$store.getters.swInfoType };
      rodtepSwInfoType = this.setInvoiceAndItemSrNo(rodtepSwInfoType);
      rodtepSwInfoType.srNo = 6;
      rodtepSwInfoType.infoType = "DTY";
      rodtepSwInfoType.infoQualifier = "RDT";
      rodtepSwInfoType.infoCode = "RODTEP" + rodtepClaimed;
      rodtepSwInfoType.infoText = rodtepClaimed === "Y" ? "Claimed" : "Not Claimed";
      rodtepSwInfoType.infoMsr = rodtepClaimed === "Y" ? parseFloat(this.sqcQty).toFixed(6) : null;
      rodtepSwInfoType.infoUqc = rodtepClaimed === "Y" ? this.sqcQtyUnit.textIdentifier : null;
      this.$store.commit(MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB, rodtepSwInfoType);
      this.$store.commit(MT.SORT_SW_INFO_TYPE_IN_EXPORT_JOB);
      return;
    },
    makeFieldsNull() {
      this.eximScheme = null;
      this.originDistrict = null;
      this.igstPymtStatus = null;
      this.end = null;
      this.igstAmount = null;
      this.documentType = null;
      this.sqcQty = null;
      this.sqcQtyUnit = null;
      this.alternateQty = null;
      this.alternateQtyUnit = null;
      this.igstPercent = null;
      this.category = null;
      this.ptaFta = null;
      this.igstTaxableValue = null;
      this.pmv = null;
      this.search = null;
      this.description = null;
      this.agencyCode = null;
      this.agencyName = null;
      this.documentName = null;
      return;
    }
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Document Name", value: "documentName" },
        { text: "Document Type", value: "documentType" },
        { text: "Agency Name", value: "agencyName" },
        { text: "Agency Code", value: "agencyCode" },
        { text: "Description", value: "description" },
        { text: "Action", value: "action" }
      ];
    },
    currencies() {
      return this.$store.getters.currencies;
    },
    ptaFtas() {
      return this.$store.getters.ptaFtas;
    },
    units() {
      return this.$store.getters.units;
    },
    states() {
      return this.$store.getters.states;
    },
    rodteps() {
      return this.$store.getters.rodteps;
    },
    igstPaymentStatus() {
      return this.$store.getters.igstPaymentStatus;
    },
    endUses() {
      return this.$store.getters.endUses;
    },
    eximSchemeCodes() {
      return this.$store.getters.eximSchemeCodes;
    },
    currency() {
      return this.$store.getters.currency;
    },
    originState() {
      // first get value from set duplicate variable
      if (this.originStateDuplicate !== null) {
        return this.originStateDuplicate;
      }
      return null;
    },
    districtCodes() {
      return this.$store.getters.districtCodes;
    },
    igstTaxableValue: {
      get() {
        if (this.igstTaxableValueDisplay === null) {
          const invoice = this.$store.state.ExportModuleStore.invoice;
          const invoiceFob = this.getInvoiceFob();
          const invoiceValue = invoice.invoiceValue !== null ? parseFloat(invoice.invoiceValue) : 0;
          const exchangeRate = invoice.exchangeRate !== null ? parseFloat(invoice.exchangeRate) : 1;
          const item = this.$store.state.ExportModuleStore.item;
          // cross multiplication, if
          // invoiceValue => certainFob,
          // unitPrice    => ? (how much unitPriceFob)
          const itemValue = parseFloat(item.itemValue);
          if (invoiceValue != 0) {
            return parseFloat(((itemValue * invoiceFob) / invoiceValue) * exchangeRate).toFixed(2);
          }
          return 0;
        } else {
          return this.igstTaxableValueDisplay;
        }
      },
      set(value) {
        if (this.igstPymtStatus === "P") {
          this.isPaid = false;
          this.isLut = true;
          this.igstAmount = ((parseFloat(this.igstRate) * parseFloat(value)) / 100).toFixed(2);
          this.igstTaxableValueDisplay = value;
          if (parseInt(value) < 1) {
            value = null;
          }
          this.$store.commit(MT.SET_ITEM_TAXABLE_VALUE, { value });
        } else {
          this.isLut = true;
          this.isPaid = true;
          this.igstPercent = 0;
          this.igstTaxableValueDisplay = 0;
        }
        return;
      }
    },
    sqcQty: {
      get() {
        // first get value from set duplicate variable
        const itemQty = this.$store.state.ExportModuleStore.item.quantity;
        if (this.sqcQtyDuplicate !== null && this.sqcQtyDuplicate === itemQty) {
          return this.sqcQtyDuplicate;
        }
        return this.$store.state.ExportModuleStore.item.quantity;
      },
      set(value) {
        this.sqcQtyDuplicate = value;
        return;
      }
    },
    sqcQtyUnit: {
      get() {
        // first get value from set duplicate variable
        if (this.sqcQtyUnitDuplicate !== null) {
          return this.sqcQtyUnitDuplicate;
        }
        return this.$store.state.ExportModuleStore.item.unitOfRate;
      },
      set(value) {
        this.sqcQtyUnitDuplicate = value;
        return;
      }
    },
    cessAmount: {
      get() {
        // first get value from set duplicate variable
        if (this.cessAmountDuplicate !== null) {
          return this.cessAmountDuplicate;
        }
        return 0;
      },
      set(value) {
        this.cessAmountDuplicate = value;
        return;
      }
    },
    ptaFta: {
      get() {
        // first get value from set duplicate variable
        if (this.ptaFtaDuplicate !== null) {
          return this.ptaFtaDuplicate.textIdentifier;
        }
        return 0;
      },
      set(value) {
        this.ptaFtaDuplicate = value;
        return;
      }
    },
    originDistrict: {
      get() {
        // first get value from set duplicate variable
        if (this.originDistrictDuplicate !== null) {
          return this.originDistrictDuplicate;
        }
        return null;
      },
      set(value) {
        this.originDistrictDuplicate = value;
        this.originStateDuplicate = value;
        return;
      }
    },
    eximSchemeDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.schemeCodeDropdownValue;
      },
      set(schemeCodeObject) {
        if (schemeCodeObject != null || schemeCodeObject != undefined) {
          this.$store.commit(MT.SET_ITEM_SCHEME_CODE_DROPDOWN_VALUE, { value: schemeCodeObject.text });
          this.$emit("selected-exim-scheme", schemeCodeObject);
          this.$store.commit(MT.SET_SCHEME_ABBREVIATION, {
            scheme: schemeCodeObject.applicableExpSchemes,
            itemSrNo: this.itemSrNo,
            invoiceSrNo: this.invoiceSrNo
          });
          this.eximScheme = schemeCodeObject.code;
          return;
        }
      }
    },
    eximScheme: {
      get() {
        return this.$store.state.ExportModuleStore.item.schemeCode;
      },
      set(scheme) {
        if (scheme !== null) {
          this.$store.commit(MT.SET_ITEM_SCHEME_CODE, { value: scheme });
        }
        return;
      }
    },
    rewardItem: {
      get() {
        const rewardItem = this.$store.state.ExportModuleStore.item.rewardItem;
        if (rewardItem === null || rewardItem === "N") {
          return false;
        }
        return true;
      },
      set(selection) {
        selection = selection ? "Y" : "N";
        this.$store.commit(MT.SET_ITEM_REWARD_ITEM, { value: selection });
        return;
      }
    },
    isThirdParty: {
      get() {
        const isThirdParty = this.$store.state.ExportModuleStore.item.isThirdParty;
        if (isThirdParty === null || isThirdParty === "N") {
          return false;
        } else {
          return true;
        }
      },
      set(selection) {
        selection = selection ? "Y" : "N";
        this.$store.commit(MT.SET_ITEM_IS_THIRD_PARTY, { value: selection });
        return;
      }
    },
    rodtepClaimed: {
      get() {
        const rodtepClaimed = this.$store.state.ExportModuleStore.item.rodtepClaimed;
        if (rodtepClaimed === null || rodtepClaimed === undefined) {
          return "N";
        }
        return "Y";
      },
      set(selection) {
        const rodtepDeclaration = this.rodtepDeclarationObject(selection);
        if (selection.textIdentifier === "Y") {
          this.$store.commit(MT.SET_STATEMENT_IN_EXPORT_JOB, rodtepDeclaration);
        } else {
          this.$store.commit(MT.REMOVE_RODTEP_STATEMENT_IN_EXPORT_JOB, rodtepDeclaration);
        }
        this.$store.commit(MT.SET_ITEM_RODTEP_CLAIMED, { value: selection.textIdentifier });
        return;
      }
    },
    pmvCalculationPercentage: {
      get() {
        const pmvCalculationPercentage = this.$store.state.ExportModuleStore.item.pmvCalculationPercentage;
        return pmvCalculationPercentage !== null ? pmvCalculationPercentage : 110;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_PMV_CALULATION_PERCENTAGE, { value });
        return;
      }
    },
    pmv: {
      get() {
        const presentMarketValue = this.$store.state.ExportModuleStore.item.presentMarketValue;
        // null means new job
        if (presentMarketValue === null || isNaN(presentMarketValue)) {
          const invoice = this.$store.state.ExportModuleStore.invoice;
          const invoiceValue = invoice.invoiceValue !== null ? parseFloat(invoice.invoiceValue) : 0;
          const exchangeRate = invoice.exchangeRate !== null ? parseFloat(invoice.exchangeRate) : 1;
          const invoiceFob = this.getInvoiceFob();
          const item = this.$store.state.ExportModuleStore.item;
          // cross multiplication, if
          // invoiceValue => certainFob,
          // unitPrice    => ? (how much unitPriceFob)
          const itemUnitPrice = parseFloat(item.unitPrice);
          if (invoiceValue != 0) {
            const itemUnitPriceFobInr = ((itemUnitPrice * invoiceFob) / invoiceValue) * exchangeRate;
            const pmvPerUnit = itemUnitPriceFobInr * (parseInt(this.pmvCalculationPercentage) / 100);
            return parseFloat(pmvPerUnit).toFixed(2);
          } else {
            return parseFloat(presentMarketValue).toFixed(2);
          }
        }
        return parseFloat(presentMarketValue).toFixed(3);
        //   return 0;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_PRESENT_MARKET_VALUE, { value: value });
        return;
      }
    },

    igstPymtStatus: {
      get() {
        return this.$store.state.ExportModuleStore.item.igstPaymentStatus;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_IGST_PAYMENT_STATUS, { value });
      }
    },
    igstPercent: {
      get() {
        return this.$store.state.ExportModuleStore.item.igstPercent ?? this.igstRate;
      },
      set(value) {
        if (value === "" || value === null) {
          value = 0;
        }
        this.igstRate = value;
        this.igstAmount = ((parseFloat(value) * parseFloat(this.igstTaxableValue)) / 100).toFixed(2);
        this.$store.commit(MT.SET_ITEM_IGST_PERCENT, { value });
        return;
      }
    },
    igstPaymentStatusDropdownValue: {
      get() {
        const selectedigstPymtStatus = this.igstPymtStatus;
        if (selectedigstPymtStatus !== "" && !!selectedigstPymtStatus) {
          return this.igstPaymentStatus.find(type => type.textIdentifier.includes(selectedigstPymtStatus));
        } else {
          return this.igstPaymentStatus;
        }
      },
      set(igstPymtStatusObject) {
        if (igstPymtStatusObject.textIdentifier === "P") {
          this.igstTaxableValueDisplay = null;
          this.igstPercent = 5;
        } else {
          this.igstPercent = 0;
          this.igstTaxableValue = 0;
        }
        this.$store.commit(MT.SET_ITEM_IGST_PAYMENT_STATUS, {
          value: igstPymtStatusObject.textIdentifier
        });
      }
    },
    end: {
      get() {
        return this.$store.state.ExportModuleStore.item.endUseOfItem;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_END_USE_OF_ITEM, { value });
      }
    },
    endDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.endUseOfItemDropdownValue;
      },
      set(endObject) {
        this.$store.commit(MT.SET_ITEM_END_USE_OF_ITEM_DROPDOWN_VALUE, { value: endObject.text });
        this.end = endObject.textIdentifier;
      }
    },
    igstAmount: {
      get() {
        return this.$store.state.ExportModuleStore.item.igstAmount;
      },
      set(value) {
        if (parseInt(value) < 1) {
          value = null;
        }
        this.$store.commit(MT.SET_ITEM_IGST_AMOUNT, { value });
      }
    }
  }
};
</script>
<style lang="scss">
.main-tab {
  &__form {
    &__pmv {
      border: solid 2px darkgrey;
      border-radius: 10px;
    }
  }
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
